/**
 * Enum for Report Types
 * @readonly
 * @enum {name: {value: number}}
 */

export const ReportTypesEnum = Object.freeze({
  myAttendance: 1,
  attendanceReport: 2,
  projectTagging: 3,
  attendanceManagement: 4,
  breakLogs: 6,
  breakMonitoringReport: 7
});
